import React, { useEffect, useState } from 'react';
import PanelShell from '../PanelShell';

const NotPanel = ({ nodeType, nodeId, data, onChange }) => {
  const [input, setInput] = useState(data?.input || '');
  useEffect(()=>{ setInput(data?.input || ''); }, [data]);
  if (nodeType !== 'Not') return null;
  const save=()=> onChange({ label:'Not', input, Title:`NOT(${input})` });
  return (
    <PanelShell title="NOT" onSave={save}>
      <input value={input} onChange={e=>setInput(e.target.value)} />
    </PanelShell>
  );
};
export default NotPanel;
